import { FaArrowRightLong } from 'react-icons/fa6';
import AnchorLink from '../AnchorLink';
import Container from '../Container';
import Heading from '../Heading';
import Card from './Card';
import styles from './styles.module.css'
import EmptyState from '../EmptyState';

const Testimonial = ({testimonial}) => {

    if(testimonial.length === 0) {
        return (
            <EmptyState 
                message={'Testimonial data empty.'}
            />
        )
    }

    const viewMore = testimonial.view_more;
    return (
        <section className={`${styles['section-10']} bg-black py-5`}>
            <Container className="py-0 py-lg-5">
                {testimonial.heading &&
                    <div className='row'>
                        <div className='col-12'>
                            <Heading 
                                heading={testimonial.heading}
                                description={testimonial.description}
                            />
                        </div>
                    </div>
                }
                
                {testimonial.reviews && testimonial.reviews.length > 0 && 
                    <div className='row mt-4 mt-lg-5'>
                        {testimonial.reviews.map(item =>
                            <Card 
                                reviewer={item.reviewer}
                                star={item.star}
                                companyName={item.company_name}
                                starNumber={item.starNumber}
                                review={item.review}
                                datetime={item.datetime}
                                key={item.id}
                            />
                        )}
                    </div>
                }
                {testimonial.show_view_more && 
                    <div className='text-center mt-5'>
                        <AnchorLink 
                            icon={viewMore.icon}
                            iconPostion={viewMore.icon_postion}
                            title={viewMore.button_label}
                            href={viewMore.button_link}
                        />
                    </div>
                }                
            </Container>
        </section>
    );
};

export default Testimonial;